/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, none, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { CommunicationMeetingMapper } from '../communications';
import { SfMeetingDto } from './meeting.dto';

@Injectable()
export class MeetingRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  create(sfId: ID, meeting: SfMeetingDto): Observable<SfMeetingDto> {
    return this.httpPost(`${this.bp}/leads/sales-folders/${sfId}/meetings`, meeting, CommunicationMeetingMapper);
  }

  update(sfId: ID, meeting: SfMeetingDto): Observable<SfMeetingDto> {
    return this.httpPut(
      `${this.bp}/leads/sales-folders/${sfId}/meetings/${meeting.id}`,
      meeting,
      CommunicationMeetingMapper);
  }

  remove(sfId: ID, meeting: SfMeetingDto): Observable<void> {
    return this.httpDelete(
      `${this.bp}/leads/sales-folders/${sfId}/meetings/${meeting.id}`,
      meeting,
      CommunicationMeetingMapper,
      none());
  }
}
